<div coreUIGrid="standard" class="drop-group builder-container Core-SiteContent" coreUIDropListGroup
    *ngIf="(errorOnLoadState$ | async) === false" #audienceDefinitionScroll>
    <div [coreUIGridItem]="4" class="picker-container" *ngIf="!isBuilderView">
    <lib-picker *ngIf="contextId" [ngClass]="limitScroll ? 'limitScroll' : ''" [contextId]="contextId"
    [dataUniverseId]="dataUniverseId" [activeDedupeType]="audienceForm?.get('dedupeType')?.value"
    [isProductTypeDcdp]="isProductTypeDcdp"></lib-picker>
    </div>
    <lib-builder-form [updateCountSuccess]="updateCountSuccess" [coreUIGridItem]="8" class="libBuilderForm" *ngIf="audienceForm" [activeDedupeType]="audienceForm?.get('dedupeType').value" [isEdit]="isEdit" [audienceForm]="audienceForm"
        (handleInvalidDefinitionError)="handleInvalidDefinitionError()" (submitUpdateCount)="submitUpdateCount($event)"
        >
    </lib-builder-form>
</div>

<coreui-notification notificationStyle="error" [isPersistent]="false" #errorNotification>
    {{ errorMessage }}
  </coreui-notification>
